import React from 'react'

function Home() {
    return (
        <>
            {/* Hero Start */}
            <div className="container-fluid pt-4 bg-primary hero-header mb-5">
                <div className="container pt-5">
                    <div className="row g-5 pt-5">
                        <div className="col-lg-6 align-self-center text-center text-lg-start mb-lg-5">
                            <div className="btn btn-sm border rounded-pill text-white px-3 mb-3 animated slideInRight">
                                Bluevipers Technology
                            </div>
                            <h1 className="display-4 text-white mb-4 animated slideInRight">
                                Smart Digital Solutions That Grow Your Business
                            </h1>
                            <p className="text-white mb-4 animated slideInRight">
                                We provide AI-powered business automation, web development, branding,
                                and custom software solutions to help businesses streamline operations
                                and scale with confidence.
                            </p>
                            <a href="tel:8459432930" className="btn btn-outline-light py-sm-3 px-sm-5 rounded-pill animated slideInRight">
                                Call Now
                            </a>
                        </div>
                        <div className="col-lg-6 align-self-end text-center text-lg-end">
                            <img className="img-fluid" src="assets/img/hero-img.png" alt="Bluevipers Technology" />
                        </div>
                    </div>
                </div>
            </div>
            {/* Hero End */}

            {/* Hero End */}
            {/* Full Screen Search Start */}
            <div className="modal fade" id="searchModal" tabIndex={-1}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: 'rgba(20, 24, 62, 0.7)' }}>
                        <div className="modal-header border-0">
                            <button type="button" className="btn btn-square bg-white btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body d-flex align-items-center justify-content-center">
                            <div className="input-group" style={{ maxWidth: 600 }}>
                                <input type="text" className="form-control bg-transparent border-light p-3" placeholder="Type search keyword" />
                                <button className="btn btn-light px-4"><i className="bi bi-search" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Full Screen Search End */}
            {/* About Start */}
            <div className="container-fluid py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                            <div className="about-img">
                                <img className="img-fluid" src="assets/img/about.png" />
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                            <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">About Us</div>
                            <h1 className="mb-4">We Transform Businesses with Intelligent Technology</h1>
                            <p className="mb-4">
                                Bluevipers Technology is a leading digital solutions and AI innovation company.
                                We help businesses grow smarter by integrating automation, modern software,
                                and strategic brand development. Our mission is to empower organizations with
                                technology that improves efficiency, reduces workload, and builds meaningful
                                digital experiences.
                            </p>
                            <p className="mb-4">
                                With a team of passionate developers, designers, and business strategists,
                                we deliver end-to-end solutions — from custom software development to websites,
                                AI chatbots, ERP systems, mobile apps, and digital marketing.
                                We focus on quality, performance, and long-term growth.
                            </p>

                            <div className="row g-3">
                                <div className="col-sm-6">
                                    <h6 className="mb-3"><i className="fa fa-check text-primary me-2" />Experienced Team</h6>
                                    <h6 className="mb-0"><i className="fa fa-check text-primary me-2" />Quality Driven Approach</h6>
                                </div>
                                <div className="col-sm-6">
                                    <h6 className="mb-3"><i className="fa fa-check text-primary me-2" />24/7 Client Support</h6>
                                    <h6 className="mb-0"><i className="fa fa-check text-primary me-2" />Affordable Pricing</h6>
                                </div>
                            </div>

                            <div className="d-flex align-items-center mt-4">
                                <a className="btn btn-primary rounded-pill px-4 me-3" href="#">Read More</a>
                                <a className="btn btn-outline-primary btn-square me-3" href="#"><i className="fab fa-facebook-f" /></a>
                                <a className="btn btn-outline-primary btn-square me-3" href="#"><i className="fab fa-twitter" /></a>
                                <a className="btn btn-outline-primary btn-square me-3" href="#"><i className="fab fa-instagram" /></a>
                                <a className="btn btn-outline-primary btn-square" href="#"><i className="fab fa-linkedin-in" /></a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}
            {/* Service Start */}
            <div className="container-fluid bg-light mt-5 py-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
                            <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Our Services</div>
                            <h1 className="mb-4">Complete Digital Solutions For Your Business</h1>
                            <p className="mb-4">
                                We provide professional web development, software solutions, customized mobile apps,
                                and digital marketing services to help businesses build strong online presence and
                                streamline their operations.
                            </p>
                        </div>

                        <div className="col-lg-7">
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <div className="row g-4">
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.1s">
                                            <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                                                <div className="service-icon btn-square">
                                                    <i className="fa fa-globe fa-2x" />
                                                </div>
                                                <h5 className="mb-3">Website Development</h5>
                                                <p>Responsive, modern, and user-friendly websites tailored for your business needs.</p>
                                                <a className="btn px-3 mt-auto mx-auto" href="/websites">View More</a>
                                            </div>
                                        </div>

                                        <div className="col-12 wow fadeIn" data-wow-delay="0.5s">
                                            <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                                                <div className="service-icon btn-square">
                                                    <i className="fa fa-code fa-2x" />
                                                </div>
                                                <h5 className="mb-3">Software Development</h5>
                                                <p>Custom software solutions to automate operations and boost efficiency.</p>
                                                <a className="btn px-3 mt-auto mx-auto" href="/customized-softwares">View More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 pt-md-4">
                                    <div className="row g-4">
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                                            <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                                                <div className="service-icon btn-square">
                                                    <i className="fa fa-mobile-alt fa-2x" />
                                                </div>
                                                <h5 className="mb-3">Mobile App Development</h5>
                                                <p>Android & iOS applications built with smooth performance and modern UI.</p>
                                                <a className="btn px-3 mt-auto mx-auto" href="/android-applications">View More</a>
                                            </div>
                                        </div>

                                        <div className="col-12 wow fadeIn" data-wow-delay="0.7s">
                                            <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                                                <div className="service-icon btn-square">
                                                    <i className="fa fa-bullhorn fa-2x" />
                                                </div>
                                                <h5 className="mb-3">Digital Marketing</h5>
                                                <p>Promote your brand online with SEO, social media campaigns, and digital ads.</p>
                                                <a className="btn px-3 mt-auto mx-auto" href="/social-media-marketing">View More</a>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Feature Start */}
            <div className="container-fluid bg-primary feature pt-5">
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-lg-6 align-self-center mb-md-5 pb-md-5 wow fadeIn" data-wow-delay="0.3s">
                            <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Us</div>
                            <h1 className="text-white mb-4">We Build Reliable & High-Quality Digital Solutions</h1>
                            <p className="text-light mb-4">
                                At Bluevipers Technology, we focus on delivering meaningful digital transformation.
                                Our experienced team ensures that every website, software and mobile app is built
                                with performance, security, and user experience in mind.
                            </p>

                            <div className="d-flex align-items-center text-white mb-3">
                                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                                    <i className="fa fa-check" />
                                </div>
                                <span>Custom Solutions Designed for Your Business Needs</span>
                            </div>

                            <div className="d-flex align-items-center text-white mb-3">
                                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                                    <i className="fa fa-check" />
                                </div>
                                <span>Professional Team with Industry-Level Expertise</span>
                            </div>

                            <div className="d-flex align-items-center text-white mb-3">
                                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                                    <i className="fa fa-check" />
                                </div>
                                <span>Fast Support, On-Time Delivery & Transparent Pricing</span>
                            </div>

                            <div className="row g-4 pt-3">
                                <div className="col-sm-6">
                                    <div className="d-flex rounded p-3" style={{ background: 'rgba(256, 256, 256, 0.1)' }}>
                                        <i className="fa fa-users fa-3x text-white" />
                                        <div className="ms-3">
                                            <h2 className="text-white mb-0" data-toggle="counter-up">100+</h2>
                                            <p className="text-white mb-0">Happy Clients</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex rounded p-3" style={{ background: 'rgba(256, 256, 256, 0.1)' }}>
                                        <i className="fa fa-check fa-3x text-white" />
                                        <div className="ms-3">
                                            <h2 className="text-white mb-0" data-toggle="counter-up">65+</h2>
                                            <p className="text-white mb-0">Projects Delivered</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 align-self-end text-center text-md-end wow fadeIn" data-wow-delay="0.5s">
                            <img className="img-fluid" src="assets/img/feature.png" alt="Bluevipers Technology" />
                        </div>
                    </div>
                </div>
            </div>
            {/* Feature End */}

            {/* FAQs Start */}
            <div className="container-fluid py-5">
                <div className="container py-5">
                    <div className="mx-auto text-center wow fadeIn" data-wow-delay="0.1s" style={{ maxWidth: 500 }}>
                        <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Popular FAQs</div>
                        <h1 className="mb-4">Frequently Asked Questions</h1>
                    </div>
                    <div className="row">

                        {/* Left Column */}
                        <div className="col-lg-6">
                            <div className="accordion" id="accordionFAQ1">

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.1s">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                                            How do I start a project with your company?
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ1">
                                        <div className="accordion-body">
                                            Simply contact us through our website or call our support team. We will discuss your requirements, suggest the best solution and share a project proposal along with timelines & cost.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.2s">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                                            How long does it take to develop a website or software?
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ1">
                                        <div className="accordion-body">
                                            The timeline depends on project size and features. A standard website takes 7-15 days, while custom business solutions may take 1-3 months. We provide a clear timeline before starting.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.3s">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                                            Do you provide domain & hosting services?
                                        </button>
                                    </h2>
                                    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ1">
                                        <div className="accordion-body">
                                            Yes, we provide domain registration, secure hosting, server setup, SSL installation & website maintenance support.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.4s">
                                    <h2 className="accordion-header" id="headingFour">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                                            Will my website & application be mobile-friendly?
                                        </button>
                                    </h2>
                                    <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ1">
                                        <div className="accordion-body">
                                            Yes, all our websites and applications are fully responsive and optimized for all devices including mobile, tablet and desktop.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-lg-6">
                            <div className="accordion" id="accordionFAQ2">

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.5s">
                                    <h2 className="accordion-header" id="headingFive">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                                            Do you provide ongoing maintenance & support?
                                        </button>
                                    </h2>
                                    <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ2">
                                        <div className="accordion-body">
                                            Yes, we provide monthly and yearly support plans depending on your needs. We ensure your software stays updated, secure and optimized.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.6s">
                                    <h2 className="accordion-header" id="headingSix">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                                            Do you offer budget-friendly packages for startups?
                                        </button>
                                    </h2>
                                    <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ2">
                                        <div className="accordion-body">
                                            Yes, we have flexible pricing packages for small businesses and startups. Tell us your budget & we'll recommend the most suitable solution.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.7s">
                                    <h2 className="accordion-header" id="headingSeven">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven">
                                            Do you provide custom mobile app development?
                                        </button>
                                    </h2>
                                    <div id="collapseSeven" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ2">
                                        <div className="accordion-body">
                                            Yes, we create Android, iOS and cross-platform applications tailored to business workflows and user experience requirements.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item wow fadeIn" data-wow-delay="0.8s">
                                    <h2 className="accordion-header" id="headingEight">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight">
                                            What technologies do you use for development?
                                        </button>
                                    </h2>
                                    <div id="collapseEight" className="accordion-collapse collapse" data-bs-parent="#accordionFAQ2">
                                        <div className="accordion-body">
                                            We work with latest technologies including React, Laravel, Node.js, PHP, Flutter, MySQL, Firebase, Python, AI/ML tools & Cloud Platforms.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* FAQs End */}
            {/* Team Start */}
            <div className="container-fluid bg-light py-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
                            <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Our Team</div>
                            <h1 className="mb-4">Meet Our Skilled & Passionate Team</h1>
                            <p className="mb-4">
                                At Bluevipers Technology, our success is fueled by a dynamic team of tech innovators,
                                problem-solvers, and creators committed to delivering excellence. Each member brings deep
                                experience, creativity, and a passion for building future-ready digital solutions.
                            </p>
                            <a className="btn btn-primary rounded-pill px-4" href="#">Learn More</a>
                        </div>

                        <div className="col-lg-7">
                            <div className="row g-4">

                                <div className="col-md-6">
                                    <div className="row g-4">
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.1s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="team1.png" alt />
                                                <h5 className="mb-0">Mr. Rohan Thorat</h5>
                                                <small>Founder </small>
                                            </div>
                                        </div>

                                        <div className="col-12 wow fadeIn" data-wow-delay="0.5s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="team2.png" alt />
                                                <h5 className="mb-0">Mr. Sanjay Waghmare</h5>
                                                <small>Sales Executive</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 pt-md-4">
                                    <div className="row g-4">
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="team3.png" alt />
                                                <h5 className="mb-0">Mr. Nilesh Sonwane</h5>
                                                <small>Sales Executive</small>
                                            </div>
                                        </div>

                                        {/* <div className="col-12 wow fadeIn" data-wow-delay="0.7s">
                                            <div className="team-item bg-white text-center rounded p-4 pt-0">
                                                <img className="img-fluid rounded-circle p-4" src="assets/img/team-4.jpg" alt />
                                                <h5 className="mb-0">Priya Shinde</h5>
                                                <small>UX/UI Designer</small>
                                            </div>
                                        </div> */}

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Team End */}
            {/* Testimonial Start */}
            {/* <div className="container-xxl py-5">
                <div className="container py-5">
                    <div className="row g-5">
                        <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
                            <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Testimonial</div>
                            <h1 className="mb-4">What Say Our Clients!</h1>
                            <p className="mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum et tempor sit. Aliqu diam
                                amet diam et eos labore. Clita erat ipsum et lorem et sit, sed stet no labore lorem sit. Sanctus
                                clita duo justo et tempor eirmod magna dolore erat amet</p>
                            <a className="btn btn-primary rounded-pill px-4" href>Read More</a>
                        </div>
                        <div className="col-lg-7 wow fadeIn" data-wow-delay="0.5s">
                            <div className="owl-carousel testimonial-carousel border-start border-primary">
                                <div className="testimonial-item ps-5">
                                    <i className="fa fa-quote-left fa-2x text-primary mb-3" />
                                    <p className="fs-4">Aliqu diam amet diam et eos labore. Clita erat ipsum et lorem et sit, sed stet no labore lorem sit. Sanctus clita duo justo et tempor eirmod magna dolore erat amet</p>
                                    <div className="d-flex align-items-center">
                                        <img className="img-fluid flex-shrink-0 rounded-circle" src="assets/img/testimonial-1.jpg" style={{ width: 60, height: 60 }} />
                                        <div className="ps-3">
                                            <h5 className="mb-1">Client Name</h5>
                                            <span>Profession</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-item ps-5">
                                    <i className="fa fa-quote-left fa-2x text-primary mb-3" />
                                    <p className="fs-4">Aliqu diam amet diam et eos labore. Clita erat ipsum et lorem et sit, sed stet no labore lorem sit. Sanctus clita duo justo et tempor eirmod magna dolore erat amet</p>
                                    <div className="d-flex align-items-center">
                                        <img className="img-fluid flex-shrink-0 rounded-circle" src="assets/img/testimonial-2.jpg" style={{ width: 60, height: 60 }} />
                                        <div className="ps-3">
                                            <h5 className="mb-1">Client Name</h5>
                                            <span>Profession</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-item ps-5">
                                    <i className="fa fa-quote-left fa-2x text-primary mb-3" />
                                    <p className="fs-4">Aliqu diam amet diam et eos labore. Clita erat ipsum et lorem et sit, sed stet no labore lorem sit. Sanctus clita duo justo et tempor eirmod magna dolore erat amet</p>
                                    <div className="d-flex align-items-center">
                                        <img className="img-fluid flex-shrink-0 rounded-circle" src="assets/img/testimonial-3.jpg" style={{ width: 60, height: 60 }} />
                                        <div className="ps-3">
                                            <h5 className="mb-1">Client Name</h5>
                                            <span>Profession</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* Testimonial End */}
        </>
    )
}

export default Home